import React, { Component } from 'react';
import Switch from '../../Part_Sample/Switch';
import Select from '../../Part_Sample/Select';

export default class Command_Notification extends Component {
	constructor(props) {
		super(props);

		this.state = {
			is_enabled: this.props.action_details.notify != null ? true : false,
			notify: this.props.action_details.notify != null ? this.props.action_details.notify : false
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		let is_enabled = false;
		if (nextProps.action_details.notify != null) is_enabled = true;
		if (is_enabled != nextState.is_enabled) {
			this.setState({
				is_enabled: is_enabled,
			})
		}

		let notify = nextProps.action_details.notify != null ? nextProps.action_details.notify : false

		if (notify != nextState.notify) {
			this.setState({
				notify: notify
			})
		}
		return true;
	}

	handleToggleEnable = () => {
		let is_enabled = !this.state.is_enabled
		this.setState({ is_enabled: is_enabled })
		if (is_enabled) {
			this.props.handleChangeNotification(this.state.notify);
		} else {
			this.props.handleChangeNotification(null);
		}
	}

	handleChangeNotification = (val) => {
		if (this.state.is_enabled) {
			this.props.handleChangeNotification(val);
			this.setState({ notify: val });
		} else {
			window.app.showToast(this.props.receiver.getString('no_enabled'), 3000);
			return;
		}
	}

	render() {
		let style = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20,
		}

		let range = [];
		if (this.state.notify) {
			range.push(<option selected='selected' value={true}>{this.props.receiver.getString('enable')}</option>);
			range.push(<option value={false}>{this.props.receiver.getString('disable')}</option>);
		} else {
			range.push(<option value={true}>{this.props.receiver.getString('enable')}</option>);
			range.push(<option selected='selected' value={false}>{this.props.receiver.getString('disable')}</option>);
		}

		return (
			<div style={style}>
				<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
					<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 2, marginLeft: 5, width: this.props.width - 185 }}>
					<span>{this.props.receiver.getString('notifications')}</span>
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', width: 90 }}>
					<Select
						options={range}
						value={this.state.notify}
						onSelect={this.handleChangeNotification}
					/>
				</div>
			</div>
		)
	}
}